import { render, staticRenderFns } from "./contactUS.vue?vue&type=template&id=6479d9fe&scoped=true"
import script from "./contactUS.vue?vue&type=script&lang=js"
export * from "./contactUS.vue?vue&type=script&lang=js"
import style0 from "./contactUS.vue?vue&type=style&index=0&id=6479d9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479d9fe",
  null
  
)

export default component.exports